import {
    REQUEST_USERS_PENDING,
    REQUEST_USERS_SUCCESS,
    REQUEST_USERS_FAILED,
    REQUEST_TOP_USERS_PENDING,
    REQUEST_TOP_USERS_SUCCESS,
    REQUEST_TOP_USERS_FAILED,
    REQUEST_FOLLOWERS_PENDING,
    REQUEST_FOLLOWERS_SUCCESS,
    REQUEST_FOLLOWERS_FAILED,
    REQUEST_CUSTOMIZE_PENDING,
    REQUEST_CUSTOMIZE_SUCCESS,
    REQUEST_CUSTOMIZE_FAILED,
    COLOR_BUTTON,
    COLOR_BACKGROUND,
    FONT_SIZE,
    REQUEST_ROOM_PENDING,
    REQUEST_ROOM_SUCCESS,
    REQUEST_ROOM_FAILED,
    SECOND_USER,
    REQUEST_SECOND_USER_PENDING,
    REQUEST_SECOND_USER_SUCCESS,
    REQUEST_SECOND_USER_FAILED,
    ROOM_MESSAGES,
    REQUEST_ROOM_MESSAGES_PENDING,
    REQUEST_ROOM_MESSAGES_SUCCESS,
    REQUEST_ROOM_MESSAGES_FAILED,
    SECTION_TITLE,
    REQUEST_USER_PENDING,
    REQUEST_USER_SUCCESS,
    REQUEST_USER_FAILED,
    EDIT_PROFILE_FIRSTNAME,
    EDIT_PROFILE_LASTNAME,
    EDIT_PROFILE_USERNAME,
    EDIT_PROFILE_DESCRIPTION,
    EDIT_PROFILE_BIRTHDAY,
    REQUEST_HOME_POSTS_PENDING,
    REQUEST_HOME_POSTS_SUCCESS,
    REQUEST_HOME_POSTS_FAILED,
    DIALOG_TWEET_SHOW,
    DIALOG_CUSTOMIZE_SHOW,
    BACK_BUTTON_SHOW,
    ROOMS_SECOND_USER_ID_ARRAY
} from "../constants/constants.js";

const initialStateUsers = {
    isPending: false,
    users: [],
    error: ""
}


export const requestUsers = (state = initialStateUsers,action = {}) => {
    switch (action.type) {
        case REQUEST_USERS_PENDING:
            return {...state, isPending: true};
        case REQUEST_USERS_SUCCESS:
            return {...state, users: action.payload,isPending: false};
        case REQUEST_USERS_FAILED:
            return {...state, error: action.payload,isPending: false};
        default:
            return state;
    }
}

const initialStateTopUsers = {
    isPending: false,
    top_users: [],
    error: ""
}


export const requestTopUsers = (state = initialStateTopUsers,action = {}) => {
    switch (action.type) {
        case REQUEST_TOP_USERS_PENDING:
            return {...state, isPending: true};
        case REQUEST_TOP_USERS_SUCCESS:
            return {...state, top_users: action.payload,isPending: false};
        case REQUEST_TOP_USERS_FAILED:
            return {...state, error: action.payload,isPending: false};
        default:
            return state;
    }
}

const initialStateNumberFollowers = {
    isPending: false,
    followers: "",
    error: ""
}


export const getNumberFollowers = (state = initialStateNumberFollowers,action = {}) => {
    switch (action.type) {
        case REQUEST_FOLLOWERS_PENDING:
            return {...state, isPending: true};
        case REQUEST_FOLLOWERS_SUCCESS:
            return {...state, followers: action.payload,isPending: false};
        case REQUEST_FOLLOWERS_FAILED:
            return {...state, error: action.payload,isPending: false};
        default:
            return state;
    }
}

const initialState_Customize = {
    isPending: false,
    customize: [],
    error: ""
}

export const getCustomize = (state = initialState_Customize,action = {}) => {
    switch (action.type) {
        case REQUEST_CUSTOMIZE_PENDING:
            return {...state, isPending: true};
        case REQUEST_CUSTOMIZE_SUCCESS:
            return {...state, customize: action.payload,isPending: false};
        case REQUEST_CUSTOMIZE_FAILED:
            return {...state, error: action.payload,isPending: false};
        default:
            return state;
    }
}

const initialState_FontSize = {
    font_size:"",
    isPending: false,
    error: ""
}

export const getFontSize = (state = initialState_FontSize, action={}) => {
    switch (action.type) {
        case REQUEST_CUSTOMIZE_PENDING:
            return {...state, isPending: true};
        case REQUEST_CUSTOMIZE_SUCCESS:
            return {...state, font_size: action.payload.font_size,isPending: false};
        case REQUEST_CUSTOMIZE_FAILED:
            return {...state, error: action.payload,isPending: false};
        case FONT_SIZE:
            return {...state, font_size: action.payload, isPending: true};
        default:
            return {...state}
    }
}

const initialState_ColorButton = {
    color_button:"",
    isPending: false,
    error: ""
}

export const getColorButton = (state = initialState_ColorButton, action={}) => {
    switch (action.type) {
        case REQUEST_CUSTOMIZE_PENDING:
            return {...state, isPending: true};
        case REQUEST_CUSTOMIZE_SUCCESS:
            return {...state, color_button: action.payload.color_button,isPending: false};
        case REQUEST_CUSTOMIZE_FAILED:
            return {...state, error: action.payload,isPending: false};
        case COLOR_BUTTON:
            return {...state, color_button: action.payload, isPending: true};
        default:
            return {...state}
    }
}

const initialState_ColorBackground = {
    color_background:"",
    isPending: false,
    error: ""
}

export const getColorBackground = (state = initialState_ColorBackground, action={}) => {
    switch (action.type) {
        case REQUEST_CUSTOMIZE_PENDING:
            return {...state, isPending: true};
        case REQUEST_CUSTOMIZE_SUCCESS:
            return {...state, color_background: action.payload.color_background,isPending: false};
        case REQUEST_CUSTOMIZE_FAILED:
            return {...state, error: action.payload,isPending: false};
        case COLOR_BACKGROUND:
            return {...state, color_background: action.payload, isPending: true};
        default:
            return {...state}
    }
}

const initialState_Room = {
    isPending: false,
    room: [],
    error: ""
}

export const getRoom = (state = initialState_Room,action = {}) => {
    switch (action.type) {
        case REQUEST_ROOM_PENDING:
            return {...state, isPending: true};
        case REQUEST_ROOM_SUCCESS:
            return {...state, room: action.payload,isPending: false};
        case REQUEST_ROOM_FAILED:
            return {...state, error: action.payload,isPending: false};
        default:
            return state;
    }
}

const initialState_SecondUser = {
    isPending: false,
    second_user: [],
    error: ""
}

export const getSecondUser = (state = initialState_SecondUser,action = {}) => {
    switch (action.type) {
        case SECOND_USER:
            return {...state, second_user: action.payload};
        case REQUEST_SECOND_USER_PENDING:
            return {...state, isPending: true};
        case REQUEST_SECOND_USER_SUCCESS:
            return {...state, second_user: action.payload,isPending: false};
        case REQUEST_SECOND_USER_FAILED:
            return {...state, error: action.payload,isPending: false};
        default:
            return state;
    }
}

const initialState_RoomMessages = {
    isPending: false,
    room_messages: [],
    error: ""
}

export const getRoomMessages = (state = initialState_RoomMessages,action = {}) => {
    switch (action.type) {
        case ROOM_MESSAGES:
            return {...state, room_messages: action.payload};
        case REQUEST_ROOM_MESSAGES_PENDING:
            return {...state, isPending: true};
        case REQUEST_ROOM_MESSAGES_SUCCESS:
            return {...state, room_messages: action.payload,isPending: false};
        case REQUEST_ROOM_MESSAGES_FAILED:
            return {...state, error: action.payload,isPending: false};
        default:
            return state;
    }
}

const initialState_Title = {
    title:""
}

export const getSectionTitle = (state = initialState_Title,action = {}) => {
    switch (action.type) {
        case SECTION_TITLE:
            return {...state, title: action.payload};
        default:
            return state;
    }
}

const initialState_RoomsSecondUserIdArray = {
    rooms_second_user_id_array:[]
}

export const setRoomsSecondUserIdArray = (state = initialState_RoomsSecondUserIdArray,action = {}) => {
    switch (action.type) {
        case ROOMS_SECOND_USER_ID_ARRAY:
            return {...state, rooms_second_user_id_array: action.payload};
        default:
            return state;
    }
}

const initialState_DialogTweet_Show = {
    dialog_tweet_show:"hide"
}

export const setDialogTweetShow = (state = initialState_DialogTweet_Show,action = {}) => {
    switch (action.type) {
        case DIALOG_TWEET_SHOW:
            return {...state, dialog_tweet_show: action.payload};
        default:
            return state;
    }
}

const initialState_DialogCustomize_Show = {
    dialog_customize_show:"hide"
}

export const setDialogCustomizeShow = (state = initialState_DialogCustomize_Show,action = {}) => {
    switch (action.type) {
        case DIALOG_CUSTOMIZE_SHOW:
            return {...state, dialog_customize_show: action.payload};
        default:
            return state;
    }
}

const initialState_BackButton_Show = {
    back_button_show:"hide"
}

export const setBackButtonShow = (state = initialState_BackButton_Show,action = {}) => {
    switch (action.type) {
        case BACK_BUTTON_SHOW:
            return {...state, back_button_show: action.payload};
        default:
            return state;
    }
}

const initialState_User = {
    isPending: false,
    user: [],
    error: ""
}

export const getUser = (state = initialState_User,action = {}) => {
    switch (action.type) {
        case REQUEST_USER_PENDING:
            return {...state, isPending: true};
        case REQUEST_USER_SUCCESS:
            return {...state, user: action.payload,isPending: false};
        case REQUEST_USER_FAILED:
            return {...state, error: action.payload,isPending: false};
        default:
            return state;
    }
}

const initialState_HomePosts = {
    isPending: false,
    home_posts: [],
    error: ""
}

export const getHomePosts = (state = initialState_HomePosts,action = {}) => {
    switch (action.type) {
        case REQUEST_HOME_POSTS_PENDING:
            return {...state, isPending: true};
        case REQUEST_HOME_POSTS_SUCCESS:
            return {...state, home_posts: action.payload,isPending: false};
        case REQUEST_HOME_POSTS_FAILED:
            return {...state, error: action.payload,isPending: false};
        default:
            return state;
    }
}

const initialState_EditFirstName = {
    edit_firstName:""
}

export const editFirstName = (state = initialState_EditFirstName,action = {}) => {
    switch (action.type) {
        case EDIT_PROFILE_FIRSTNAME:
            return {...state, edit_firstName: action.payload};
        default:
            return state;
    }
}

const initialState_EditLastName = {
    edit_lastName:""
}

export const editLastName = (state = initialState_EditLastName,action = {}) => {
    switch (action.type) {
        case EDIT_PROFILE_LASTNAME:
            return {...state, edit_lastName: action.payload};
        default:
            return state;
    }
}

const initialState_EditUserName = {
    edit_userName:""
}

export const editUserName = (state = initialState_EditUserName,action = {}) => {
    switch (action.type) {
        case EDIT_PROFILE_USERNAME:
            return {...state, edit_userName: action.payload};
        default:
            return state;
    }
}

const initialState_EditDescription = {
    edit_description:""
}

export const editDescription = (state = initialState_EditDescription,action = {}) => {
    switch (action.type) {
        case EDIT_PROFILE_DESCRIPTION:
            return {...state, edit_description: action.payload};
        default:
            return state;
    }
}

const initialState_EditBirthday = {
    edit_birthday:""
}

export const editBirthday = (state = initialState_EditBirthday,action = {}) => {
    switch (action.type) {
        case EDIT_PROFILE_BIRTHDAY:
            return {...state, edit_birthday: action.payload};
        default:
            return state;
    }
}